import React from "react";
import { Grid, SimpleGrid, Box, Heading, Text, Image, Tooltip } from "@chakra-ui/react";
import { motion, AnimatePresence } from "framer-motion";

const SkillsSection = () => {
  const skillSections = [
    {
      title: "Visual Softwares",
      icons: ["affinity", "figma", "photoshop", "illustrator", "indesign", "adobe-xd"],
    },
    {
      title: "Font Development",
      icons: ["html", "css", "react", "threejs", "javascript", "php"],
    },
    {
      title: "Marketing & SEO",
      icons: ["hotjar", "seo", "mailchimp", "webflow", "hubspot", "google-analytics"],
    },
    {
      title: "UX/UI",
      icons: ["figma", "adobe-xd", "hotjar", "framer", "zeplin", "sketch"],
    },
    {
      title: "Video and 3D",
      icons: ["davinci-resolve", "premiere", "after-effects", "blender", "threejs", "cinema-4d"],
    },
    {
      title: "AI Tools",
      icons: ["google-cloud", "google-antigravity", "cursor", "n8n", "comfyui", "ollama"],
    },
  ];

  return (
    <AnimatePresence>
      <Grid
        templateColumns={{
          base: "1fr",
          sm: "repeat(2, 1fr)",
          md: "repeat(2, 2fr)",
          lg: "repeat(3, 2fr)",
        }}
        gap={{ base: "10px", md: "30px" }}
        justifyContent="center"
        key="skills-grid"
      >
        {skillSections.map((skill, index) => (
          <motion.div
            key={index}
            gridColumn={{
              lg: index === 4 ? "2 / 3" : index === 5 ? "3 / 4" : "auto",
            }}
            whileInView={{ opacity: 1, y: "0" }}
            transition={{ ease: "linear", delay: 0.2 * index }}
            h="100%"
            style={{ opacity: 0, y: "2vw" }}
          >
            <SkillSection skill={skill} />
          </motion.div>
        ))}
      </Grid>
    </AnimatePresence>
  );
};

const SkillSection = React.memo(({ skill }) => {
  return (
    <Box
      color="#F9F0DF"
      display={"flex"}
      flexDir={{ base: "row", sm: "column" }}
      alignItems={"center"}
      justifyContent={"center"}
      textAlign="center"
      pos="relative"
    >
      <Box
        w="fit-content"
        display="inline-grid"
        border="3px dashed rgba(0, 0, 0, 0.5);"
        bg={"#F9F0DF"}
        rounded="15px"
        backdropFilter={"blur(1px)"}
      >
        <SimpleGrid
          display="inline-grid"
          columns={{ base: "3", md: "6" }}
          spacing={{ base: "10px", md: "13px" }}
          p={{ base: "6px", md: "15px" }}
        >
          {skill.icons.map((icon) => (
            <Tooltip
              key={icon}
              label={icon.replace("-", " ").replace(/\b\w/g, (l) => l.toUpperCase())}
              aria-label={icon.replace("-", " ").replace(/\b\w/g, (l) => l.toUpperCase())}
            >
              <Image
                _hover={{ transform: "scale(1.2)", transition: "all .2s ease-in-out" }}
                src={`./skills-icons/${icon}.svg`}
                alt={icon.replace("-", " ").replace(/\b\w/g, (l) => l.toUpperCase())}
              />
            </Tooltip>
          ))}
        </SimpleGrid>
      </Box>
      <Box
        justifyContent={{ base: "left", sm: "center" }}
        bg={"#333333"}
        p={{ base: 2, sm: 4 }}
        pt={{ base: 2, sm: 8 }}
        pl={{ base: 8, sm: 8 }}
        rounded="15px"
        w="calc(100% - 40px)"
        mt={{ base: 0, sm: -4 }}
        ml={{ base: -4, sm: 2 }}
      >
        <Heading mb={{ base: "0", md: "10px" }} size={{ base: "xs", md: "md" }}>
          {skill.title}
        </Heading>
        <Text fontSize={{ base: "xs", md: "md" }} lineHeight={{ base: "1", md: "1.5" }}>
          {skill.icons
            .map((icon) => icon.replace("-", " ").replace(/\b\w/g, (l) => l.toUpperCase()))
            .join(", ")}
        </Text>
      </Box>
    </Box>
  );
});

export default React.memo(SkillsSection);
